import { TypographyProps, useTypography } from "./useTypography";

const Typography = (props: TypographyProps) => {
  const renderElement = useTypography(props);
  return renderElement;
};

export default Typography;
